import React from 'react';
import { hesitations } from '../data/content';
import { LeafSprig } from './decor/LeafSprig';
export function Problem() {
  return <section aria-labelledby="problem-title" className="bg-paper" data-id="element-230" data-mp="2peyz4ik9xwg9">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-231" data-mp="2bgisermew5y4">
        <h2 id="problem-title" className="mx-auto max-w-3xl text-balance text-center font-display text-[38px] leading-[1.05] text-navy sm:text-[54px]" data-id="element-232" data-mp="2gesnl284z6jq">
          Combien de graines de l’Évangile avez-vous semées cette semaine ?
        </h2>

        <div className="mt-14 grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-233" data-mp="26heks5f4yg9w">
          <div className="space-y-5 text-lg leading-relaxed text-ink-soft" data-id="element-234" data-mp="1spro44ha75ql">
            <p className="font-display text-2xl leading-snug text-navy sm:text-[28px]" data-id="element-235" data-mp="1sneyr6971t3i">Jésus nous a dit d’aller et de faire des disciples.</p>
            <p data-id="element-236" data-mp="1is3ey9ixhvow">
              Mais parfois, une journée de plus passe.
              <br data-id="element-237" data-mp="1npvhryl4327v" />
              Puis une semaine de plus.
            </p>
            <p data-id="element-238" data-mp="1nrzkweb6rx73">Nous allons au travail. Nous faisons nos courses. Nous entrons dans des magasins. Nous parlons à nos voisins. Nous croisons des gens partout…</p>
            <p className="border-l-4 border-coral pl-5 font-bold text-navy" data-id="element-239" data-mp="oa2c141ovkib">Et pourtant, une nouvelle occasion de partager Christ nous échappe.</p>
          </div>

          <div data-id="element-240" data-mp="xbs5sgj1mvj9">
            <p className="text-lg leading-relaxed text-ink-soft" data-id="element-241" data-mp="xbac9rnrmvf1">
              Peut-être désirez-vous sincèrement évangéliser, mais chaque fois que l’occasion se présente, vous vous dites :
            </p>
            <ul className="mt-6 flex flex-wrap gap-3" data-id="element-242" data-mp="5ldw6wi2c5de">
              {hesitations.map(h => <li key={h} className="rounded-2xl rounded-bl-sm bg-white px-5 py-3 font-display text-xl text-ink-soft shadow-card ring-1 ring-cream-line" data-id="element-243" data-mp="jcsqw0lc1v0a">
                  « {h} »
                </li>)}
            </ul>
            <p className="mt-8 text-lg leading-relaxed text-ink-soft" data-id="element-244" data-mp="3mz19ene2mci5">
              Et sans même vous en rendre compte, votre routine est devenue la raison pour laquelle vous repoussez sans cesse la mission que Dieu
              vous a déjà confiée.
            </p>
          </div>
        </div>

        <div className="relative mx-auto mt-16 max-w-3xl rounded-[28px] bg-leaf-wash px-6 py-12 text-center sm:px-12" data-id="element-245" data-mp="1qvv4hay4msd3">
          <LeafSprig className="mx-auto h-16 w-8 text-leaf-deep" data-id="element-246" data-mp="1vqsb6b7xopmt" />
          <p className="mt-4 text-lg font-semibold text-navy sm:text-xl" data-id="element-247" data-mp="20mzio8fza96v">Mais partager l’Évangile ne commence pas toujours par un sermon.</p>
          <p className="mt-3 font-display text-3xl leading-tight text-navy sm:text-[42px]" data-id="element-248" data-mp="17ytxxloxck71">
            Parfois… tout commence par <span className="italic text-leaf-deep" data-id="element-249" data-mp="1cxewlgoj2vtd">une petite graine.</span>
          </p>
        </div>
      </div>
    </section>;
}